import type { TranslationTree } from '../../types';

export const adminTools: TranslationTree = {
  adminTools: {
    tab: 'Suppression d’outils',
    title: 'Administration des outils',
    subtitle:
      'Supprimez des outils ou des références entières pour votre entreprise. Les suppressions sont définitives et effacent les traces d’usinage de chaque outil supprimé.',
    loading: 'Chargement des outils…',
    summary: {
      references: '{{count}} références',
      tools: '{{count}} outils',
      unreferenced: '{{count}} outils sans référence',
    },
    group: {
      count: '{{count}} outils',
      alias: 'alias : « {{alias}} »',
    },
    unreferenced: {
      title: 'Outils sans référence — suppression individuelle uniquement',
    },
    dates: {
      line: 'créé {{created}} · modifié {{updated}}',
      none: 'aucune trace',
    },
    actions: {
      deleteTool: 'Supprimer',
      deleteReference: 'Supprimer la référence',
      retry: 'Réessayer',
    },
    dialog: {
      cancel: 'Annuler',
      tool: {
        title: 'Supprimer l’outil {{toolId}} ?',
        description:
          'Cette action supprime l’outil {{toolId}} et toutes ses traces d’usinage. Elle est irréversible.',
        confirm: 'Supprimer l’outil',
      },
      reference: {
        title: 'Supprimer la référence {{reference}} ?',
        description:
          'Cette action supprime les {{count}} outils de la référence {{reference}}, toutes leurs traces d’usinage, ainsi que l’alias de la référence. Elle est irréversible.',
        descriptionAliasOnly:
          'La référence {{reference}} n’a aucun outil — cette action supprime son alias. Elle est irréversible.',
        confirm: 'Supprimer la référence',
      },
    },
    error: {
      generic: 'La suppression a échoué. Veuillez réessayer.',
    },
  },
};
